'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = exports.ERROR_NO_OPTION = exports.ERROR_CURRENT_VARIANT = exports.ERROR_SWATCH_POSITION = exports.SWATCH_VALUE_DISPLAY_SELECTOR = exports.SWATCH_SELECTOR_SELECTOR = exports.SWATCH_OBJECT_SELECTOR = exports.SWATCH_CONTAINER_SELECTOR = exports.ON_VARIANT_CHANGE = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _VariantSelector2 = require('./../variant/VariantSelector');

Object.defineProperty(exports, 'ON_VARIANT_CHANGE', {
  enumerable: true,
  get: function get() {
    return _VariantSelector2.ON_VARIANT_CHANGE;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var SWATCH_CONTAINER_SELECTOR = exports.SWATCH_CONTAINER_SELECTOR = '[data-swatches]';
var SWATCH_OBJECT_SELECTOR = exports.SWATCH_OBJECT_SELECTOR = '[data-swatch-object]';
var SWATCH_SELECTOR_SELECTOR = exports.SWATCH_SELECTOR_SELECTOR = '[data-swatch-selector]';
var SWATCH_VALUE_DISPLAY_SELECTOR = exports.SWATCH_VALUE_DISPLAY_SELECTOR = '[data-swatch-value]';

//Errors
var ERROR_SWATCH_POSITION = exports.ERROR_SWATCH_POSITION = 'Target Swatch is missing the position attribute! [data-swatch-position]';
var ERROR_CURRENT_VARIANT = exports.ERROR_CURRENT_VARIANT = 'Failed to get currently selected variant!';
var ERROR_NO_OPTION = exports.ERROR_NO_OPTION = 'Failed to find a variant selector option to match current swatch selection!';

//Class

var Swatch = exports.Swatch = function (_VariantSelector) {
  (0, _inherits3.default)(Swatch, _VariantSelector);

  function Swatch(container) {
    (0, _classCallCheck3.default)(this, Swatch);

    //Trigger an update on page load.
    var _this = (0, _possibleConstructorReturn3.default)(this, (Swatch.__proto__ || Object.getPrototypeOf(Swatch)).call(this, container));

    _this.updateAvailableSwatches();
    return _this;
  }

  (0, _createClass3.default)(Swatch, [{
    key: 'onSwatchClicked',
    value: function onSwatchClicked(e) {
      var self = $(e.currentTarget);
      this.setVariantFromSwatch(self, self.attr('data-value'));
    }
  }, {
    key: 'onSwatchSelected',
    value: function onSwatchSelected(e) {
      var self = $(e.currentTarget);
      this.setVariantFromSwatch(self, self.val());
    }
  }, {
    key: 'onSwatchVariantChanged',
    value: function onSwatchVariantChanged(variant, variantId) {
      //All swatch objects lose focus
      this.container.find(SWATCH_OBJECT_SELECTOR).removeClass('is-selected');

      //Trigger an update (this will hide/show appropriate swatches)
      this.updateAvailableSwatches();

      //Now iterate over the options...
      for (var i = 1; i <= this.data.options.length; i++) {
        //Get value at this option
        var value = variant.options[i - 1];
        var ps = '[data-swatch-position="' + i + '"]'; //Position Selector
        var vs = '[data-value="' + value + '"]'; //Value Selector

        //Now we can add the class to the selected object
        this.container.find(SWATCH_OBJECT_SELECTOR + ps + vs).addClass('is-selected');

        //Change the value of the selectors
        this.container.find(SWATCH_SELECTOR_SELECTOR + ps).val(value);

        this.container.find(SWATCH_VALUE_DISPLAY_SELECTOR + ps).html(value.toLowerCase());
      }
    }
  }, {
    key: 'setVariant',
    value: function setVariant(id) {
      (0, _get3.default)(Swatch.prototype.__proto__ || Object.getPrototypeOf(Swatch.prototype), 'setVariant', this).call(this, id);

      //Fetch data and update the swatches
      var variant = this.data.variants.find(function (v) {
        return v.id == id;
      });
      return this.onSwatchVariantChanged(variant, id);
    }
  }, {
    key: 'setVariantFromSwatch',
    value: function setVariantFromSwatch(el, value) {
      //Triggers a standard variant change based on a swatch

      //Get the current swatch index and position
      var _map = ['data-index', 'data-swatch-position'].map(function (e) {
        return el.attr(e);
      }),
          _map2 = (0, _slicedToArray3.default)(_map, 2),
          index = _map2[0],
          position = _map2[1];

      if (!position) throw new Error(ERROR_SWATCH_POSITION);

      //Get the current variant data.
      var currentVariant = this.getVariantData();
      if (!currentVariant) throw new Error(ERROR_CURRENT_VARIANT);

      //Ok so I was running into a problem regarding multiple levels of variants
      //And this is caused by non standard variants
      //e.g. if a product has the variants:
      // Material Cloth, Color Red
      // Material Cloth, Color Blue
      // Material Silk, Color Red
      // Material Silk, Color Green
      //It will show the color green even if the material is currently cloth, and
      //Will fail to select the variant if there's.. yada yada etc etc basically
      //we need to only show variant subs for variants of top level-ness

      //This is the <option> from within the standard variant selector we're trying
      //to fetch and read the variant id from!
      var selector = '[data-variant-option]';
      var target = void 0;

      //Now, for each option (1..2..3)
      for (var i = 1; i <= this.data.options.length; i++) {
        var selectorValue = void 0; //We will store the value for this option index, e.g. "Red" for Option1 and "Silk" for Option2...

        //Get the current value at this option
        selectorValue = currentVariant.options[i - 1];

        //However, if this index is the position of the swatch that was triggering this update, then use ITS value (thus updating
        if (i == position) selectorValue = value;

        //Store Current jQuery selector
        var selectorTemp = '' + selector;

        //Append to the new selector..
        selector += '[data-option' + i + '="' + selectorValue + '"]';

        //Now we need to check if the variant we're after even exists.
        target = this.container.find(selector);

        //If it DOESN'T, then the current option index doesn't exist (e.g. Option1 is Silk Okay, But Option2 is Blue, not okay)
        if (target.length) continue;

        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = selectorTemp + '[data-option' + i + ']:first';
        target = this.container.find(selector);
      }

      //Now we should have a selector for a variant that actually exists, let's get it
      if (!target.length) {
        throw new Error(ERROR_NO_OPTION + '\nSelector' + selector);
      }

      //Find the variant ID based from the selection, and set it.
      this.setVariant(target.val());
    }
  }, {
    key: 'updateAvailableSwatches',
    value: function updateAvailableSwatches() {
      var _this2 = this;

      var current = this.getVariantData();

      //Set Swatch Objects to hidden & sold out
      var objects = this.container.find(SWATCH_OBJECT_SELECTOR);
      ['is-sold-out'].forEach(function (e) {
        return objects.addClass(e);
      });

      //Hide swatch selector options
      this.container.find(SWATCH_SELECTOR_SELECTOR + ' option').attr('disabled', 'disabled');

      //Top level are always visibile, if there's sub levels
      var tls = '[data-swatch-position="1"]';
      this.container.find(SWATCH_OBJECT_SELECTOR + tls).removeClass('is-hidden');
      this.container.find(SWATCH_SELECTOR_SELECTOR + tls + ' option').removeAttr('disabled');

      //Now go over reach option to determine visible swatches

      var _loop = function _loop(i) {
        //Given the selected previous level, what options for *this* level are available?
        var pi = 'option' + (i - 1);
        var prevOption = current[pi];

        var allowedOptionsForThisLevel = [];
        _this2.data.variants.forEach(function (v) {
          var n = v["option" + i];

          //If current iterated variant has the same previous option AND is not already in the list of allowed values...
          if (allowedOptionsForThisLevel.indexOf(n) === -1 && v[pi] == prevOption) {
            allowedOptionsForThisLevel.push(n); //Add to list.
          }
        });

        allowedOptionsForThisLevel.forEach(function (ao) {
          var aos = '[data-swatch-position="' + i + '"]';
          _this2.container.find(SWATCH_OBJECT_SELECTOR + aos + ('[data-value="' + ao + '"]')).removeClass('is-hidden');
          // this.container.find(SWATCH_SELECTOR_SELECTOR+aos+` [value="${ao}"]`).removeAttr('disabled');
        });
      };

      for (var i = 2; i <= this.data.options.length; i++) {
        _loop(i);
      }

      //Now determine what's sold out for each given level

      var _loop2 = function _loop2(i) {
        var avail = {}; //Stores availability of option[i]'s value.

        //Find if there are any variants for this option with stock available
        _this2.data.variants.forEach(function (v) {
          //Check previous options match, since we don't want to check stock of
          //other levels
          var canUse = true;
          for (var y = 1; y < i; y++) {
            var oy = 'option' + y;
            if (v[oy] == current[oy]) continue;
            canUse = false;
            break;
          }
          if (!canUse) return;

          var n = v["option" + i];
          if ((0, _typeof3.default)(avail[n]) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) avail[n] = v.available;
          avail[n] = avail[n] || v.available;
        });

        //Now remove these as sold out.
        var keys = Object.entries(avail).forEach(function (e) {
          var _e = (0, _slicedToArray3.default)(e, 2),
              key = _e[0],
              value = _e[1];

          if (!value) return;
          _this2.container.find(SWATCH_OBJECT_SELECTOR + '[data-swatch-position="' + i + '"][data-value="' + key + '"]').removeClass('is-sold-out');
          _this2.container.find(SWATCH_SELECTOR_SELECTOR + '[data-swatch-position="' + i + '"] [value="' + key + '"]').removeAttr('disabled');
        });
      };

      for (var i = 1; i <= this.data.options.length; i++) {
        _loop2(i);
      }
    }
  }, {
    key: 'attachEvents',
    value: function attachEvents() {
      var _this3 = this;

      (0, _get3.default)(Swatch.prototype.__proto__ || Object.getPrototypeOf(Swatch.prototype), 'attachEvents', this).call(this);

      this.boundSwatchClick = function (e) {
        return _this3.onSwatchClicked(e);
      };
      this.container.on('click', SWATCH_OBJECT_SELECTOR, this.boundSwatchClick);

      this.boundSwatchSelect = function (e) {
        return _this3.onSwatchSelected(e);
      };
      this.container.on('change', SWATCH_SELECTOR_SELECTOR, this.boundSwatchSelect);

      if (this.shouldUseEvents()) {
        this.boundSwatchVariantChange = function (e, variant, variantId) {
          return _this3.onSwatchVariantChanged(variant, variantId);
        };
        $(document).on(_VariantSelector2.ON_VARIANT_CHANGE, this.boundSwatchVariantChange);
      }
    }
  }, {
    key: 'detachEvents',
    value: function detachEvents() {
      (0, _get3.default)(Swatch.prototype.__proto__ || Object.getPrototypeOf(Swatch.prototype), 'detachEvents', this).call(this);

      if (this.boundSwatchClick) this.container.off('click', SWATCH_OBJECT_SELECTOR, this.boundSwatchClick);
      if (this.boundSwatchSelect) this.container.off('change', SWATCH_SELECTOR_SELECTOR, this.boundSwatchSelect);
      if (this.boundSwatchVariantChange) $(document).off(_VariantSelector2.ON_VARIANT_CHANGE, this.boundSwatchVariantChange);
    }
  }]);
  return Swatch;
}(_VariantSelector2.VariantSelector);